'use strict'

// postcss stylesheets
import "./../styles/tailwind.pcss";
import "./../styles/main.pcss";

const scripts = {
  DOMContentLoaded: () => import('./DOMContentLoaded'),
  everythingLoaded: () => import('./everythingLoaded')
}

document.addEventListener('DOMContentLoaded', () => scripts.DOMContentLoaded().then(module => module.DOMContentLoadedInit()))
document.addEventListener('everythingLoaded', () => scripts.everythingLoaded().then(module => module.everythingLoadedInit()))